import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DownTrendIcon, FlatTrendIcon, UpTrendIcon } from "../../../../../../../../assets/icons";
import { formatCompactNumber } from "../../../../../../../../common/utils";

const getDeltaConfig = (value?: number, isDelta?: boolean) => {
	if (!isDelta || value === undefined) {
		return {
			icon: null,
			color: "primary" as const,
		};
	}

	if (value > 0) {
		return {
			icon: <UpTrendIcon fontSize="small" color="error" />,
			color: "error" as const,
		};
	}

	if (value < 0) {
		return {
			icon: <DownTrendIcon fontSize="small" color="success" />,
			color: "success" as const,
		};
	}

	return {
		icon: <FlatTrendIcon fontSize="small" color="info" />,
		color: "info" as const,
	};
};

export const MetricValue = ({
	label,
	value,
	measure,
	isDelta,
	maximumFractionDigits,
}: {
	label?: string;
	value?: number;
	measure?: string;
	isDelta?: boolean;
	maximumFractionDigits?: number;
}) => {
	const delta = getDeltaConfig(value, isDelta);
	const { t } = useTranslation("whatif.rootcause");

	return (
		<Stack>
			<Typography variant="subtitle2" fontWeight={500} color="textSecondary">
				{label} {isDelta && t("root cause results/aggregate scenario/delta")}
			</Typography>

			<Stack spacing={1} direction="row" alignItems="end">
				<Stack direction={"row"} alignItems={"center"} spacing={1}>
					{delta.icon}

					<Typography variant="h4" fontWeight={400} color={delta.color}>
						{value !== undefined && (
							<>{formatCompactNumber(value, 0, maximumFractionDigits ? maximumFractionDigits : 1)}</>
						)}
					</Typography>
				</Stack>

				<Typography variant="caption" color="textSecondary" pb={0.4}>
					{measure}
				</Typography>
			</Stack>
		</Stack>
	);
};
